angular.module('common.services', [])
angular.module('surfsightApp.controllers', ['common.directives'])
angular.module('common.directives', ['common.services'])
angular
  .module('surfsightApp.controllers')
  .factory('httpInterceptor', [
    '$localStorage',
    function ($localStorage) {
      return {
        request: function (config) {
          const regex = new RegExp(BASE_DOMAIN, 'i')
          if (regex.test(config.url)) {
            config.headers = config.headers || {}
            config.headers = {
              'X-Request-Origin': 'White Label Portal',
              'Content-Type': 'application/json',
              Authorization: /\/v2\//.test(config.url)
                ? `Bearer ${$localStorage.userToken}`
                : $localStorage.userToken,
              ...config.headers
            }
          }
          return config
        }
      }
    }
  ])
  .config([
    '$httpProvider',
    function ($httpProvider) {
      $httpProvider.interceptors.push('httpInterceptor')
    }
  ])
